/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PlanSettingsScenariosType from '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsScenarios.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { Props } from '@jira/portfolio-3__portfolio/src/app-simple-plans/view/settings/scenarios/types.tsx';

/**
 * Plan Settings - scenarios page
 */

export const LazyPlanSettingsScenarios: LazyComponent<
	({ store, ...props }: Props) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanSettingsScenariosType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-settings-scenarios", jiraSpaEntry: "async-plan-settings-scenarios" */ '@jira/spa-apps__advanced-roadmaps-plan-settings/src/PlanSettingsScenarios.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanSettingsScenarios = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanSettingsScenarios} pageId="plan-settings-scenarios" shouldShowSpinner />
);

export default AsyncPlanSettingsScenarios;
